module.exports = __webpack_public_path__ + "img/bg-type03-pc-mask.71e066ff.png";